import {
  InternalChromeConfig,
  getChromeContext as btswGetChromeContext,
} from '@amzn/aac-chrome-internal-api';
import { isBtswContext, isFromTrim, isFromBtswWc } from 'src/commons/utils';
import getChromeData from './get-chrome-data';

export default async (): Promise<InternalChromeConfig> => {
  if (isFromTrim()) {
    // Trim initializes the internal configuration using by setting it in the InternalChromeConfigHandler
    //code.amazon.com/packages/AdvertisingConsoleTrimService/blobs/fe07fbf147a3f15f6d3b82b6369ee828a6f8720d/--/src/main/resources/META-INF/resources/views/headerView.jsp#L36
    return window.AACChrome.InternalAPI.InternalChromeConfigHandler.getInstance()
      .internalChromeConfig as InternalChromeConfig;
  } else if (isBtswContext() || isFromBtswWc()) {
    return btswGetChromeContext();
  }

  const chromeData = await getChromeData();
  return chromeData.internalChromeConfig;
};
